import { createFileRoute } from "@tanstack/react-router"
import { AccountPage } from "@/app"

export const Route = createFileRoute("/(user)/(tenantBc)/account")({
  component: RouteComponent,
})

function RouteComponent() {
  return <AccountPage />
}
